module.exports = __webpack_public_path__ + "static/img/2_1_1.6eab8dc8.jpg";